import { render, staticRenderFns } from "./MaquinasLista.vue?vue&type=template&id=248aaa90&scoped=true&"
import script from "./MaquinasLista.vue?vue&type=script&lang=js&"
export * from "./MaquinasLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248aaa90",
  null
  
)

export default component.exports